import EventsRouteBuilder from "~/cabinet/ts/routes/EventsRouteBuilder";

export const CLIENT_EVENTS_ROUTES_BUILDER = new EventsRouteBuilder("CLIENT_EVENTS");
